var map = {
	"./woman_glove_1.png": "I91x",
	"./woman_glove_2.png": "gdP9",
	"./woman_glove_3.png": "zXna",
	"./woman_glove_4.png": "bW1Q",
	"./woman_glove_5.png": "jalP",
	"./woman_glove_6.png": "UTxx"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ZuE6";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/woman_glove_.*\.png$
// module id = ZuE6
// module chunks = 0